<template>
  <div class="flex flex-col mb-4 font-display">
    <label
      :for="name"
      class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
      >{{ label }}</label
    >
    <div class="relative flex">
      <input
        :id="id"
        :name="name"
        :type="type"
        :placeholder="label"
        :value="value"
        @focus="focusValue($event.target.value)"
        @change="focusValue($event.target.value)"
        v-on:input="updateValue($event.target.value)"
        v-on:keypress="updateValue($event.target.value)"
        class="transition duration-300 ease-in z-10 focus:border-indigo-400 focus:shadow-focus rounded-r-none text-sm sm:text-base relative w-full border rounded placeholder-gray-400 focus:outline-none py-4 px-4"
      />
      <div
        class="flex align-middle border border-l-0 items-center justify-center rounded-tr rounded-br bg-gray-100 text-gray-600 text-lg px-2 md:pl-5 md:pr-20"
      >
        <span class="text-xs md:text-sm font-bold">{{ url }}</span>
      </div>
    </div>
    <div class="mt-2">
      <small class="text-blue-600 font-bold p-1 inline bg-blue-100">{{
        value + url
      }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputIcon',
  props: {
    name: String,
    type: String,
    url: String,
    label: String,
    icon: {
      type: Object,
      default: function () {
        return {
          name: 'user',
          type: 'regular'
        }
      }
    },
    value: {
      type: [String, Number]
    },
    id: String
  },
  methods: {
    toSlug(str) {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
      var to = 'aaaaeeeeiiiioooouuuunc------'
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    },
    updateValue: function (value) {
      this.$emit('input', this.toSlug(value))
    },
    focusValue: function (value) {
      this.$emit('focus', this.toSlug(value))
    }
  }
}
</script>

<style>
</style>
